import {FC, useMemo} from 'react'
import find from 'lodash/find'
import {Dropdown} from 'react-bootstrap'
import {globalFilter} from 'app/constant'

const statusTypes = [
  {
    id: 'FULFILLED',
    name: 'Fulfilled',
  },
  {
    id: 'UNFULFILLED',
    name: 'Unfulfilled',
  },
  {
    id: 'RESTOCKED',
    name: 'Restock',
  },
  {
    id: 'PARTIAL',
    name: 'Partially fulfilled',
  },
  {
    id: 'READY_TO_FULFILL',
    name: 'Ready to fulfill',
  },
]
type Props = {
  filter: any
  setFilter: (value: any) => any
}

const FulfillmentStatusFilter: FC<Props> = ({filter, setFilter}) => {
  const handleChange = (status: any) => {
    let fulfillmentStatus
    if (status === '') {
      fulfillmentStatus = null
    } else {
      fulfillmentStatus = status
    }

    setFilter({
      ...filter,
      offset: 0,
      fulfillmentStatus,
    })
  }

  const filterName = useMemo(() => {
    if (filter.fulfillmentStatus) {
      const result = find(statusTypes, {id: filter.fulfillmentStatus})
      if (result) {
        return result.name
      }
    }
    return 'Fulfillment Status'
  }, [filter.fulfillmentStatus])

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant='transparent'
        className={`${globalFilter.css} border-right-0 px-4 mt-1`}
      >
        {filterName}
      </Dropdown.Toggle>
      <Dropdown.Menu className='form-control border-dark border ms-1 mt-1'>
        <Dropdown.Item eventKey='' as='button' onSelect={handleChange}>
          All
        </Dropdown.Item>
        {statusTypes.map((status) => (
          <Dropdown.Item key={status.id} eventKey={status.id} as='button' onSelect={handleChange}>
            {status.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default FulfillmentStatusFilter
